import * as React from 'react'

import { Box, StatusLabel, Tooltip, useToggle } from '@factorialco/deprecated-design-system'
import moment from 'moment'

interface Props {
  title: string
  startOn: string
  endOn: string
}
export const CycleTag = ({ title, startOn, endOn }: Props) => {
  const [open, toggle] = useToggle()

  const label = `[${title}] - ${moment(startOn).format('LL')} - ${moment(endOn).format('LL')}`

  return (
    <Box inline>
      <Tooltip.Alt attachment="top center" label={label} open={open} toggle={toggle}>
        <StatusLabel type="neutral">{title}</StatusLabel>
      </Tooltip.Alt>
    </Box>
  )
}
